module Widgets.Form.SubForm where

import Common

import Concur.React.DOM as D
import Concur.React.Props as P
import Data.Array (catMaybes, concatMap)
import Data.Maybe (maybe)
import Data.String (Pattern(..), contains)
import GraphQL.Shape (QueryField(..), QueryShape)
import Widgets.Form.Class (class FormWidget, FormContext, FormWidgetResult, addParentId, asField, fieldId, fieldPaths)
import Widgets.Form.WidgetMap (WidgetMap, getWMData, renderWidgets, setWMData)

newtype SubForm = SubForm SubFormType
instance showSubForm :: Show SubForm where
      show (SubForm sf) = show sf
type SubFormType =
    { id :: String
    , label :: Maybe String
    , labelClass :: String
    , section :: Boolean
    , collapsible :: Boolean
    , expanded :: Boolean
    , cls :: String
    , fields :: WidgetMap
    }

instance subFormFW :: FormWidget SubForm where
    getId (SubForm sf) = sf.id
    isLeaf _ = false
    asField (SubForm state) =
        Just $ QObject state.id $ catMaybes $ map asField state.fields
    fieldPaths fc (SubForm sf) =
        concatMap (fieldPaths subfc) sf.fields
      where
        subfc = addParentId fc sf.id

    toWidget fc (SubForm sf) = subFormWrapper fc sf subWidgets
      where
        -- Append this sub-form's ID to the chain of parent IDs
        subfc = addParentId fc sf.id
        subWidgets :: Widget HTML (FormWidgetResult SubForm)
        subWidgets =
            (\f -> SubForm <$> sf { fields = _ } <$> f) <$> D.div
                [ P.className "fields-wrapper" ]
                (renderWidgets subfc sf.fields)

    getData fc (SubForm sf) = getWMData fc sf.fields
    setData fc (SubForm sf) new =
        SubForm <$> sf { fields = _ } <$> setWMData fc sf.fields new


-- HTML wrapper around the `SubForm`.
subFormWrapper :: forall a. FormContext -> SubFormType -> Widget HTML a -> Widget HTML a
subFormWrapper fc state@{ id, label, collapsible: true, expanded } children =
    D.details
        [ P.open expanded
        , P.className $ subformClasses state
        , P.key $ fieldId fc id
        , P._id $ fieldId fc id
        ]
        (maybeLabel <> [children])
  where
    maybeLabel = maybe [] (\l -> [ D.summary [ P.className state.labelClass ] [ D.text l ] ]) label

subFormWrapper fc state@{ id, label, collapsible: false } children =
    D.fieldset [ P.className $ subformClasses state, P.key $ fieldId fc id ]
        (maybeLabel <> [children])
  where
    maybeLabel = pure $ maybe emptyAnchor legend label

    emptyAnchor = D.a [ P._id $ fieldId fc id ] []

    legend l = D.legend [ P._id $ fieldId fc id, P.className state.labelClass ] [ D.text l ]

subformClasses :: SubFormType -> String
subformClasses { cls, section } = "widget-sub-form "
    <> if contains (Pattern "col-span-") cls
       then cls
       else if cls == "" then "col-span-12"
       else "col-span-12 " <> cls
    <> if section then " section" else ""

subFormShape :: SubForm -> QueryShape
subFormShape (SubForm state) = catMaybes $ map asField state.fields
